
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { updateModuleProgress } from '@/services/learning-service';
import { useToast } from '@/hooks/use-toast';

export function useLearningProgress() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [isUpdating, setIsUpdating] = useState(false);

  const markModuleCompleted = async (moduleId: string, completed: boolean = true) => {
    if (!user) {
      toast({
        title: "Authentication required",
        description: "Please sign in to track your progress",
        variant: "destructive"
      });
      return false;
    }

    setIsUpdating(true);
    try {
      await updateModuleProgress(user.id, moduleId, completed);
      
      toast({
        title: completed ? "Module completed!" : "Progress updated",
        description: completed 
          ? "Your progress has been saved" 
          : "Module marked as not completed",
      });
      
      return true;
    } catch (error) {
      console.error('Error updating module progress:', error);
      toast({
        title: "Error updating progress",
        description: "There was a problem saving your progress",
        variant: "destructive"
      });
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    markModuleCompleted,
    isUpdating
  };
}
